import { gql } from '@apollo/client';

const SenderBySlugQuery = gql`
  query SenderBySlug($slug: String!) {
    senderBySlug(slug: $slug) {
      _id
      firstName
      lastName
      title
      senderPicture {
        uri
      }
    }
  }
`;

export default SenderBySlugQuery;
